import Logo from '@/assets/images/logo/system-logo.png';

export default function HeaderPageForm() {
    return (
        <div className='w-full h-17 flex items-center justify-center'>
            <img className='h-10 point-940:h-10 object-contain' src={Logo} alt='logo' />
        </div>
    );
}
